import { createIcon } from '@chakra-ui/react'

const GenerateImageCTAIcon = createIcon({
  viewBox: '0 0 64 48',
  path: (
    <>
      <path
        d="M63.664 12.864c-3.29-28.269-17.823-1.132-31.431-1.132-13.609 0-24.64 13.467-24.64 30.08 0 16.611 16.053-6.008 26.864-1.302 10.81 4.705 32.497.623 29.207-27.646z"
        fill="#E4EBFD"
      />
      <path
        d="M23.102 31.845a.896.896 0 0 1-.892-.855.896.896 0 0 1 .85-.94c11.462-.545 13.005-7.437 13.02-7.507a.894.894 0 1 1 1.748.362c-.018.089-.467 2.192-2.554 4.338-1.87 1.925-5.493 4.285-12.13 4.6a.498.498 0 0 1-.042.002z"
        fill="#1D52CD"
      />
      <path
        d="m39.678 34.466 8.03-.383a.973.973 0 0 0-.092-1.941l-8.03.383a.973.973 0 0 0 .092 1.94zM36.07 22.4l.592 5.657c.097 2.06 1.567 3.678 3.266 3.597l7.532-.36c1.7-.08 3.01-1.832 2.913-3.891l.015-1.458.002-.277.04-3.952c-.044-.923-.702-1.648-1.463-1.611l-11.593.553c-.761.037-1.348.82-1.304 1.743z"
        fill="#4A93F3"
      />
      <path
        d="M47.239 25.889c.172.173.43.265.707.252l2.03-.097c.145-.007.285-.043.41-.1l.003-.276a.872.872 0 0 1-.425.134l-2.03.097a.69.69 0 0 1-.526-.181.43.43 0 0 1-.13-.328l.23-5.025a.495.495 0 0 1 .052-.193l-.263.012a.7.7 0 0 0-.03.17l-.23 5.026a.672.672 0 0 0 .202.509zM41.653 23.64l.013.267 1.926-.091c.607-.03 1.134-.655 1.375-1.634a14.9 14.9 0 0 1 .635-1.916l-.292.014a14.935 14.935 0 0 0-.6 1.838c-.212.86-.646 1.407-1.13 1.43l-1.927.092z"
        fill="#1D52CD"
      />
      <path
        d="M37.943 20.631c.122.233.522 1.017.813 1.848.332.951.916 1.524 1.523 1.495l1.387-.067-.013-.267-1.386.066c-.486.023-.968-.481-1.26-1.315-.26-.745-.605-1.45-.77-1.774l-.294.014z"
        fill="#1D52CD"
      />
      <path
        d="m41.795 23.767-.26.012.363 7.78.26-.012-.363-7.78zM48.151 23.057c-.05-1.084.396-1.996 1.014-2.115v-.007l.085-.004.017-.001h.016l.49-.024.01.189a1.45 1.45 0 0 1 .354.376l.14 2.977v.002c-.09.165-.197.303-.317.406l.01.19-.61.028v-.008c-.627-.059-1.157-.924-1.209-2.009z"
        fill="#1D52CD"
      />
      <path
        d="m50.76 24.426-.002.001c-.202.369-.488.604-.815.62-.67.032-1.256-.869-1.31-2.013-.054-1.142.445-2.095 1.115-2.127.327-.016.634.19.87.54l.141 2.979z"
        fill="#1D52CD"
      />
      <path
        d="M49.297 23.003c.039.823.462 1.472.944 1.45l.55-.027c-.481.023-.904-.625-.943-1.449-.039-.823.32-1.509.803-1.532l-.55.026c-.483.023-.843.709-.804 1.532z"
        fill="#E4EBFD"
      />
      <path
        d="M49.85 22.977c.038.823.46 1.472.943 1.45.482-.024.842-.71.803-1.533-.04-.823-.462-1.471-.944-1.448-.482.022-.841.708-.802 1.531zM32.303 11.89l.06 1.264c.144 3.062 2.754 5.448 5.8 5.302l9.544-.455c3.046-.145 5.42-2.769 5.275-5.83l-.06-1.265c-.133-2.82-2.357-5.066-5.088-5.29a5.552 5.552 0 0 0-.712-.012l-9.545.455a5.458 5.458 0 0 0-1.131.174 5.59 5.59 0 0 0-4.143 5.657z"
        fill="#4A93F3"
      />
      <path
        d="M50.918 8.384a2.67 2.67 0 0 0-.42-.784 3.45 3.45 0 0 0-1.404-1.08 2.515 2.515 0 0 0-.87-.196.287.287 0 0 0-.163.53l.008.005c.226.147.447.272.664.403.216.13.428.262.637.4.21.14.415.287.62.442.207.155.41.32.635.486l.003.002c.083.062.2.044.262-.04a.188.188 0 0 0 .028-.168z"
        fill="#F0F0F0"
      />
      <path
        d="m33.351 13.055.01.222c.102 2.145 1.93 3.817 4.065 3.715l7.883-.376c2.134-.102 3.797-1.94 3.696-4.086l-.01-.222a3.885 3.885 0 0 0-.813-2.204 3.885 3.885 0 0 0-3.252-1.512l-7.883.376c-2.134.102-3.797 1.941-3.696 4.087z"
        fill="#fff"
      />
      <path
        d="m40.48 7.224.012.277 1.478-.07c.582-.029 1.105-.398 1.364-.965.12-.263.27-.516.39-.7l-.335.016c-.1.166-.21.364-.304.569-.217.472-.648.78-1.128.803l-1.477.07z"
        fill="#1D52CD"
      />
      <path
        d="M37.7 6.053c.132.169.308.409.453.66.25.433.594.87 1.253.84l1.086-.052-.012-.277-1.087.052c-.418.02-.699-.177-1.002-.702a5.822 5.822 0 0 0-.356-.537l-.335.016z"
        fill="#1D52CD"
      />
      <path
        d="m43.811 16.094-4.537.24c-.778.04-1.44-.56-1.481-1.341l-.207-3.975a1.414 1.414 0 0 1 1.333-1.489l4.538-.239c.777-.04 1.44.56 1.48 1.341l.208 3.974a1.414 1.414 0 0 1-1.334 1.49z"
        fill="#F5C25E"
      />
      <path
        d="m41.09 14.01-1.131.06-.141.525-1.118.059 1.065-3.48 1.227-.064 1.416 3.349-1.122.059-.195-.507zm-.3-.79-.357-.935-.257.966.614-.032zm2.968-2.256.178 3.414-1.065.056-.178-3.413 1.065-.057z"
        fill="#000"
      />
      <path
        d="M49.68 11.82c-.061-1.314.48-2.42 1.229-2.563v-.009l.104-.005.02-.002h.02l.594-.028.01.228c.157.111.302.266.43.454l.001.002.17 3.61-.001.002c-.11.2-.239.367-.384.493l.01.23-.737.034v-.01c-.76-.07-1.404-1.12-1.465-2.435z"
        fill="#1D52CD"
      />
      <path
        d="M52.84 13.48v.002c-.245.447-.592.732-.988.75-.812.04-1.524-1.052-1.59-2.439-.065-1.386.54-2.54 1.352-2.58.397-.018.77.232 1.054.655.001 0 .002 0 .002.002l.17 3.61z"
        fill="#1D52CD"
      />
      <path
        d="M51.069 11.754c.047.998.56 1.785 1.144 1.757l.668-.032c-.585.028-1.097-.758-1.144-1.757-.047-.998.389-1.829.973-1.857l-.667.032c-.585.028-1.021.859-.974 1.857z"
        fill="#E4EBFD"
      />
      <path
        d="M51.738 11.723c.047.998.56 1.785 1.144 1.757.584-.028 1.02-.86.973-1.858-.047-.998-.56-1.784-1.144-1.756-.584.028-1.02.859-.973 1.857z"
        fill="#4A93F3"
      />
      <path
        d="m44.898 6.852.082 1.74a3.42 3.42 0 0 1 .261-.001L45.16 6.84a1.444 1.444 0 0 1 .504-1.166l-.382.018a1.7 1.7 0 0 0-.383 1.16zm-8.743.418.09 1.911a3.42 3.42 0 0 1 .262 0l-.09-1.924c-.021-.437.155-.838.45-1.117a5.003 5.003 0 0 0-.42.093c-.2.295-.31.654-.292 1.037zM43.345 35.288a19.91 19.91 0 0 1-2.276-.118.897.897 0 0 1-.777-1 .893.893 0 0 1 .995-.782c.087.011 8.745 1.012 11.493-3.685.533-.91.672-1.765.427-2.61-.552-1.903-2.892-3.147-2.915-3.159a.9.9 0 0 1-.39-1.207.89.89 0 0 1 1.201-.393c.124.064 3.044 1.586 3.818 4.255.386 1.329.183 2.683-.602 4.024-2.373 4.056-7.851 4.675-10.974 4.675z"
        fill="#1D52CD"
      />
      <path
        d="m41.548 34.655.113-.492a.776.776 0 0 0-.576-.928l-.83-.194a.772.772 0 0 0-.924.58l-.113.491a.776.776 0 0 0 .576.929l.83.193a.772.772 0 0 0 .924-.579z"
        fill="#1D52CD"
      />
      <path
        d="m23.998 31.073-.002-.505a.774.774 0 0 0-.774-.77l-.853.005a.774.774 0 0 0-.765.778l.003.505c.002.426.35.772.774.77l.852-.005a.774.774 0 0 0 .765-.778z"
        fill="#4A93F3"
      />
      <path
        d="m37.522 20.237 3.049 18.801a2.173 2.173 0 0 1-1.786 2.495L20.083 44.6a2.164 2.164 0 0 1-2.482-1.795l-3.05-18.801a2.172 2.172 0 0 1 1.786-2.495l18.702-3.066a2.163 2.163 0 0 1 2.483 1.795z"
        fill="#fff"
      />
      <path
        d="m38.925 41.51-19.56 3.207 7.021-9.808a2.4 2.4 0 0 1 3.361-.551l9.28 6.714a.245.245 0 0 1-.102.439z"
        fill="#E2F8EF"
      />
      <path
        d="m32.962 42.487-12.867 2.11a2.176 2.176 0 0 1-2.496-1.806l-1.458-8.987.013-.019a2.781 2.781 0 0 1 3.895-.639l5.006 3.62 7.907 5.721z"
        fill="#74C19D"
      />
      <path
        d="M33.717 28.275a3.11 3.11 0 0 0-.696-4.327 3.073 3.073 0 0 0-4.303.706 3.11 3.11 0 0 0 .696 4.327c1.38 1 3.307.684 4.303-.706zM10.896 21.242a3.453 3.453 0 0 1-4.455-2.014.172.172 0 1 0-.323.123c.676 1.79-.222 3.8-2.003 4.48a.174.174 0 0 0 .123.324c1.78-.68 3.779.223 4.455 2.014a.172.172 0 1 0 .322-.123c-.676-1.79.222-3.8 2.003-4.48a.174.174 0 0 0-.122-.324zm8.37-8.197a2.229 2.229 0 0 1-2.875-1.3.11.11 0 0 0-.143-.064.111.111 0 0 0-.065.143 2.248 2.248 0 0 1-1.293 2.892.111.111 0 0 0 .079.208 2.229 2.229 0 0 1 2.876 1.3.11.11 0 0 0 .143.065.111.111 0 0 0 .064-.144 2.248 2.248 0 0 1 1.293-2.891.112.112 0 0 0-.078-.209zm-7.569 22.237a2.228 2.228 0 0 1-2.876-1.3.11.11 0 0 0-.143-.065.111.111 0 0 0-.064.144 2.248 2.248 0 0 1-1.293 2.891.112.112 0 0 0 .079.209 2.229 2.229 0 0 1 2.876 1.3.11.11 0 0 0 .143.064.112.112 0 0 0 .064-.144 2.248 2.248 0 0 1 1.293-2.891.111.111 0 0 0 .064-.144.11.11 0 0 0-.143-.064z"
        fill="#F5C25E"
      />
    </>
  ),
})

export default GenerateImageCTAIcon
